import moment from 'moment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Moment } from 'moment';
import { BaseService } from '../services/base.service';
import jwt_decode from 'jwt-decode';

/** Shape returned by POST /api/auth/login */
export interface LoginResult {
  accessToken: string;
  expiresInSeconds: number;
  user: any;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BaseService {
  constructor(protected http: HttpClient) {
    super('auth', http);
  }

  login(userNameOrEmail: string, password: string): Observable<LoginResult> {
    return this.http.post<LoginResult>(`${environment.apiUrl}auth/login`, {
      userNameOrEmail,
      password,
    });
  }

  public setSession(authResult: LoginResult): void {
    const expiresAt = moment().add(authResult.expiresInSeconds, 'second');
    localStorage.setItem('id_token', authResult.accessToken);
    localStorage.setItem('expires_at', JSON.stringify(expiresAt.valueOf()));
  }

  logout(): void {
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    this.clearMustChangePassword();
  }

  // Set when a user logs in still using the shared temporary password; forces
  // them through the change-password page before they can use the app.
  private static readonly MUST_CHANGE_KEY = 'must_change_password';

  setMustChangePassword(value: boolean): void {
    if (value) {
      localStorage.setItem(AuthService.MUST_CHANGE_KEY, '1');
    } else {
      localStorage.removeItem(AuthService.MUST_CHANGE_KEY);
    }
  }

  mustChangePassword(): boolean {
    return localStorage.getItem(AuthService.MUST_CHANGE_KEY) === '1';
  }

  clearMustChangePassword(): void {
    localStorage.removeItem(AuthService.MUST_CHANGE_KEY);
  }

  public getInitialLoggedInStatus(): void {
    console.log('is logged in?', this.isLoggedIn());
  }

  public isLoggedIn(): boolean {
    return moment().isBefore(this.getExpiration());
  }

  public getFromJWT(parameter: string): any {
    const token = localStorage.getItem('id_token');
    if (!token) {
      return null;
    }
    const decodedToken = jwt_decode(token);
    return decodedToken[parameter];
  }

  isLoggedOut(): boolean {
    return !this.isLoggedIn();
  }

  getExpiration(): Moment {
    const expiration = localStorage.getItem('expires_at');
    const expiresAt = JSON.parse(expiration);
    return moment(expiresAt);
  }
}
